var _rect, _polygon, _polygon2, _polygon3, _polygon4, _polygon5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    fill: "#DE2910"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "5,2.5 5.8,5 8.4,5 6.3,6.5 7.1,9 5,7.5 2.9,9 3.7,6.5 1.6,5 4.2,5",
    fill: "#FFDE00"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "9.5,1 9.8,2 10.8,2 10,2.6 10.3,3.6 9.5,3 8.7,3.6 9,2.6 8.2,2 9.2,2",
    fill: "#FFDE00"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "11.5,3.5 11.8,4.5 12.8,4.5 12,5.1 12.3,6.1 11.5,5.5 10.7,6.1 11,5.1 10.2,4.5 11.2,4.5",
    fill: "#FFDE00"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "11.5,7 11.8,8 12.8,8 12,8.6 12.3,9.6 11.5,9 10.7,9.6 11,8.6 10.2,8 11.2,8",
    fill: "#FFDE00"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "9.5,9.5 9.8,10.5 10.8,10.5 10,11.1 10.3,12.1 9.5,11.5 8.7,12.1 9,11.1 8.2,10.5 9.2,10.5",
    fill: "#FFDE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCn);
export default __webpack_public_path__ + "static/media/cn.435bf619ff78daba293fa4354922785c.svg";
export { ForwardRef as ReactComponent };